import { Chapter } from '../interfaces/Organization';
import { MConformityDependency } from './conformity-dependency.model';

export class MChapter{
    public id: number = null;
    public help: string= "";
    public description: string = null;
    public number: string = null;
    public title: string = null;
    public conformityDependency: MConformityDependency = null;
    public aplicabilityDependency: MConformityDependency = null;

    constructor(chap: Chapter){
        this.id = chap.id;
        this.help = chap.ayuda
        this.description = chap.descripcion;
        this.number = chap.numero;
        this.title = chap.titulo;
        this.aplicabilityDependency = chap.dependencia_aplicabilidad ? new MConformityDependency(chap.dependencia_aplicabilidad) : null;
        this.conformityDependency = chap.dependencia_conformidad ? 
            new MConformityDependency(chap.dependencia_conformidad) : null;
    }

}